import { render, staticRenderFns } from "./add-organization.vue?vue&type=template&id=2693b9e4&scoped=true"
import script from "./add-organization.vue?vue&type=script&lang=js"
export * from "./add-organization.vue?vue&type=script&lang=js"
import style0 from "./add-organization.vue?vue&type=style&index=0&id=2693b9e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2693b9e4",
  null
  
)

export default component.exports